import React, { useEffect, useRef, useState } from "react";
import { X, Check, Loader } from "lucide-react";
import Spacing from "../Spacing";
import { getPaymentStatus } from "../../services/billing";
import { Drawer } from 'vaul';

export default function StatusViewModal(
  {
    openModal=false, 
    setOpenModal=()=>{},
    session='',
    loadData=()=>{},
    filterData={},
    account_id,
    payment_type,
    handleFormView = () => {},
    previousScrollPosition = 0,
  }
) {
  const [paymentStatusData, setPaymentStatusData] = useState({});
  const [checkExpired, setCheckExpired] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);
  const notifyTriggered = useRef(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (checkExpired && !notifyTriggered.current) {
      getPaymentStatusData();
    }
  }, [checkExpired]);

  const getPaymentStatusData = async () => {
    const statusData = {
      account_id: account_id,
      session_id: session,
      payment: payment_type,
    };
    try {
      const response = await getPaymentStatus(statusData);
      if (response) {
        if(response?.detail && !notifyTriggered.current) {
          notifyTriggered.current = true;
          setCheckExpired(false);
          clearURL();
          setOpenModal(false);
          window.scrollTo(0, previousScrollPosition);
        } else {
          setPaymentStatusData(response?.data);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ getPaymentStatusData ~ error:", error);
    }
  };

  const clearURL = () => {
    const url = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, url);
  }

  const downloadInvoice = (link) => {
    if (!link) return;
    setButtonLoader(true);
    const a = document.createElement("a");
    a.href = link;
    a.download = "";
    a.click();
    setTimeout(() => {
      setButtonLoader(false);
    }, 2000);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} 
        onOpenChange={(e) => {
          e.stopPropagation();
          e.preventDefault();
          clearURL();
          setOpenModal(false);
          window.scrollTo(0, previousScrollPosition);
          loadData(filterData);
        }}
      >
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Delete Record</Drawer.Title>
            <Drawer.Description className="sr-only">Delete a recorded data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal small_sm">
                <button
                  className="docpro_close_btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    clearURL();
                    setOpenModal(false);
                    window.scrollTo(0, previousScrollPosition);
                    loadData(filterData);
                  }}
                >
                  <X />
                </button>
                <div className="docpro_deleteboxbox">
                  <Spacing lg="12" sm="12" />
                  {paymentStatusData?.status === 'complete'?
                    <div className="docpro_iconbox_icon docpro_badge_green">
                      <Check width={50} height={50} />
                    </div>
                  : paymentStatusData?.status === 'expired'?
                    <div className="docpro_iconbox_icon docpro_badge_red">
                      <X width={50} height={50} />
                    </div>
                  :
                    ''
                  }
                  <Spacing lg="20" sm="20" />
                  <div className="docpro_iconbox_right">
                    {paymentStatusData?.status === 'complete'?
                      <>
                        <p className="docpro_mb_0 docpro_fs_16">
                          {paymentStatusData?.message}
                        </p>
                        {paymentStatusData?.data &&
                          <>
                            <Spacing lg="10" sm="10" />
                            <h3 className="docpro_fs_28">${paymentStatusData?.data?.received_amount ? paymentStatusData?.data?.received_amount : 0}</h3>
                            {paymentStatusData?.data?.invoice_number !== null && (
                              <div className="flex items-center justify-between docpro_ternary_color">
                                <p className="docpro_mb_0 docpro_fs_16">Invoice number</p>
                                <p className="docpro_mb_0 docpro_fs_16">{paymentStatusData?.data?.invoice_number}</p>
                              </div>
                            )}
                            <div className="flex items-center justify-between mt-1 docpro_ternary_color">
                              <p className="docpro_mb_0 docpro_fs_16">Payment date</p>
                              <p className="docpro_mb_0 docpro_fs_16">{paymentStatusData?.data?.payment_date}</p>
                            </div>
                            <div className="flex items-center justify-between mt-1 docpro_ternary_color">
                              <p className="docpro_mb_0 docpro_fs_16">Payment method</p>
                              <p className="docpro_mb_0 docpro_fs_16">{paymentStatusData?.data?.payment_details}</p>
                            </div>
                            <Spacing lg="25" sm="25" />
                            <div className="docpro_data_table_btns" style={{ padding: 0, flexWrap: 'nowrap' }}>
                              {paymentStatusData?.data?.invoice_id !== null  && (
                                <button 
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    clearURL();
                                    setOpenModal(false);
                                    window.scrollTo(0, previousScrollPosition);
                                    handleFormView(paymentStatusData?.data?.invoice_id);
                                  }}
                                  className="docpro_bordered_btn docpro_fw_600 docpro_primary_color w-full size_lg"
                                >
                                  View Invoice
                                </button>
                              )}
                              {paymentStatusData?.data?.invoice_pdf !== null  && (
                                <button 
                                  onClick={() => downloadInvoice(paymentStatusData?.data?.invoice_pdf)}
                                  className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn w-full size_lg"
                                  disabled = {buttonLoader ? true : false}
                                >
                                  Download Invoice
                                  {buttonLoader && (
                                    <span className="docpro_loading">
                                      <Loader width={20} height={20} />
                                    </span>
                                  )}
                                </button>
                              )}
                            </div>
                          </>
                        }
                      </>
                    : paymentStatusData?.status === 'expired'?
                      <p className="docpro_mb_0 docpro_fs_16">
                        {paymentStatusData?.message}
                      </p>
                    :
                      <p className="docpro_mb_0 docpro_fs_16">Processing ...</p>
                    }
                    <Spacing lg="12" sm="12" />
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
